import React, { Fragment } from 'react'
import { priceFormat } from './../../../utils/helpers'
import AwardPreviewImage from "./AwardPreviewImage";

const ShowEntries = ({entry, index, previewLink, sameLeft, sameRight}) => {
  let icon = ''
  let itemClass = "item__top_first item__top_content"

  switch (entry?.rank ? (entry.rank - 1) : index) {
    case 0: {
      icon = "/images/icon_awards-1_b.svg";
      itemClass = "item__top_first item__top_content";
      break;
    }
    case 1: {
      icon = "/images/icon_awards-2_m.svg";
      itemClass = "item__top_second item__top_content";
      break;
    }
    case 2: {
      icon = "/images/icon_awards-3_m.svg";
      itemClass = "item__top_third item__top_content";
      break;
    }
    default: ''
  }

  return entry ? (
    <div className={`${itemClass} ${sameLeft ? 'same-left' : ''} ${sameRight ? 'same-right' : ''}`}>
      <div className="awards-top-third__item">
        <div className="item-top-third-image text-center">
          <AwardPreviewImage entry={entry} previewLink={previewLink} />
        </div>
        <img
          className="icon__top"
          src={icon}
        />
        <div className="info-top-rank">
          <label className="info-top-rank__name text-truncate">
            {entry?.user?.nickname}
          </label>
          <span className="info-top-rank__point">
            {priceFormat(entry?.total_vote || 0)} <label>표</label>
          </span>
        </div>
      </div>
    </div>
  ) : <div className={itemClass}></div>
}

const AwardTop3 = ({entries = [], previewLink}) => {
  const rank1 = entries[0]?.rank ? (entries[0].rank - 1) : 0
  const rank2 = entries[1]?.rank ? (entries[1].rank - 1) : 1
  const rank3 = entries[2]?.rank ? (entries[2].rank - 1) : 2

  const rank1SameRank2 = rank1 === rank2
  const rank1SameRank3 = rank1 === rank3

  const itemRank1 = <ShowEntries
    entry={entries[0]}
    index={0}
    previewLink={previewLink}
    sameLeft={rank1SameRank2}
    sameRight={rank1SameRank3}
  />

  const itemRank2 = <ShowEntries
    entry={entries[1]}
    index={1}
    previewLink={previewLink}
    sameLeft={false}
    sameRight={rank1SameRank2}
  />

  const itemRank3 = <ShowEntries
    entry={entries[2]}
    index={2}
    previewLink={previewLink}
    sameLeft={rank1SameRank3}
    sameRight={false}
  />

  if (!entries.length) {
    return <div className="awards-top-third" style={{height: 0}}></div>
  }

  if (rank1SameRank2 && rank1SameRank3) {
    return (
      <div className="awards-top-third">
        <div className="d-flex justify-content-between same-rank same-3">
          {itemRank2}
          {itemRank1}
          {itemRank3}
        </div>
      </div>
    )
  }

  if (rank1SameRank2 && !rank1SameRank3) {
    return (
      <div className="awards-top-third">
        <div className="d-flex justify-content-between same-rank same-2">
          {itemRank2}
          {itemRank1}
        </div>
        {itemRank3}
      </div>
    )
  }

  return (
    <div className="awards-top-third">
      {itemRank2}
      {itemRank1}
      {itemRank3}
    </div>
  )
}

export default AwardTop3;
